
export default {
  name: 'AccountAuthPopup',
  props: {
    initialPopupContent: {
      type: String,
      default: 'AccountLogin',
    },
  },
  data() {
    return {
      message: null,
      popupContent: this.initialPopupContent,
      popupVariants: [
        'AccountLogin',
        'AccountSignUp',
        'AccountForgotPassword',
      ],
      customClass: 'auth_popup',
    };
  },
  beforeCreate() {
    // eslint-disable-next-line nuxt/no-globals-in-created
    document.documentElement.classList.add('auth-popup-active');
  },
  beforeDestroy() {
    document.documentElement.classList.remove('auth-popup-active');
  },
};
